import { useState, useCallback, useEffect } from "react";
import { useGetReleases } from "@services/releases/list";
import type { ReleasesFilters } from "@services/releases/list/type";
import type { ViewMode } from "@typings/pages";
import { config } from "@/config";

export function useReleasesData(
  viewMode: ViewMode,
  appliedFilters?: ReleasesFilters,
) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(config.table.defaultPageSize);

  const {
    data: releases,
    isLoading,
    error,
    mutate,
  } = useGetReleases({
    ...appliedFilters,
    limit: rowsPerPage,
    page: page + 1,
  });

  const handlePageChange = useCallback((_: unknown, newPage: number) => {
    setPage(newPage);
  }, []);

  const handleRowsPerPageChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    },
    [],
  );

  useEffect(() => {
    setPage(0);
  }, [viewMode, appliedFilters]);

  return {
    releases: releases?.items || [],
    totalItems: releases?.meta.totalItems ?? 0,
    isLoading,
    error,
    mutate,
    page,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
  };
}
